import { Record } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';

import { BREAKPOINTS_PROPS } from 'app/constants/ReduxResponsive';
import { selectSidebarWidth } from 'app/modules/Layout/Sidebar/selectors';

export const STAKE_COLUMN_WIDTH = 147;
export const GRID_FIXED_COLUMNS_WIDTH = 323; // sum of fixed grid columns (`matchDetails` = 285px and `allStakes` = 38px)

export const MATCH_CENTER_MIN_COL_WIDTH = 350;
export const MATCH_CENTER_COL_PADDING = 32;
export const MATCH_CENTER_BLOCK_WIDTH = MATCH_CENTER_MIN_COL_WIDTH + MATCH_CENTER_COL_PADDING;


const LARGE_MENU_WIDTH = 380;
const MEDIUM_MENU_WIDTH = 280;
const SMALL_MENU_WIDTH = 250;

/**
 * @type {ResponsiveProps}
 * @property {number} gridColCount
 * @property {number} matchCenterColCount
 */
const ResponsiveProps = Record(
  {
    gridColCount: null,
    matchCenterColCount: null,
  },
  'ResponsiveProps',
);

export default () => {
  /**
   * @return {number}
   */
  const leftMenuWidth = (state) => {
    const { mediaType } = state.browser;
    const { maxScreenWidth = 0 } = BREAKPOINTS_PROPS[mediaType];

    if (maxScreenWidth >= 1920) {
      return LARGE_MENU_WIDTH;
    }

    if (maxScreenWidth >= 1440) {
      return MEDIUM_MENU_WIDTH;
    }

    return SMALL_MENU_WIDTH;
  };
  /**
   * Get grid-column and menu-layer count
   * Count depending on the screen size.
   */
  return createSelector(
    leftMenuWidth,
    selectSidebarWidth,
    (state) => state.browser.mediaType,
    (leftMenuWidth, selectSidebarWidth, mediaType) => {
      const { maxScreenWidth } = BREAKPOINTS_PROPS[mediaType];

      const gridColumnsWidth = (
        maxScreenWidth - (leftMenuWidth + GRID_FIXED_COLUMNS_WIDTH + selectSidebarWidth)
      );

      const matchCenterAvailableWidth = maxScreenWidth - (selectSidebarWidth + leftMenuWidth);

      return new ResponsiveProps({
        gridColCount: Math.floor(gridColumnsWidth / STAKE_COLUMN_WIDTH),
        matchCenterColCount: Math.floor(matchCenterAvailableWidth / MATCH_CENTER_BLOCK_WIDTH),
      });
    },
  );
};
